import { Box, Card, Stack, Typography, ValidationErrors } from "@compass/core";
import {
  StudentEnrollment as StudentEnrollmentModel,
  StudentEnrollmentEditResource,
  StudentEnrollmentViewResource,
} from "generated/openApi";
import { StudentEnrollmentPageBody } from "pages/students/student-enrollments/StudentEnrollmentPage/StudentEnrollmentPageBody";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentEnrollment = (props: {
  enrollment: StudentEnrollmentModel;
  setEnrollment: (value: StudentEnrollmentModel) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const [viewResource, setViewResource] = useState<StudentEnrollmentViewResource>({});
  const [editResource, setEditResource] = useState<StudentEnrollmentEditResource>({});

  useEffect(() => {
    fetchEditResource();
    fetchViewResource();
  }, []);

  const fetchEditResource = () => {
    ApiService.studentEnrollments.getEditResource().then((response) => {
      setEditResource(response);
    });
  };

  const fetchViewResource = () => {
    ApiService.studentEnrollments.getViewResource().then((response) => {
      setViewResource(response);
    });
  };

  return (
    <Card
      header={
        <Stack>
          <Box>Enrollment</Box>
          <Typography variant="caption">
            An enrollment is required when creating a student. You may add more enrollments after succesfully creating
            this student.
          </Typography>
        </Stack>
      }
    >
      <StudentEnrollmentPageBody
        crudMode="edit"
        enrollment={props.enrollment}
        setEnrollment={props.setEnrollment}
        viewResource={viewResource}
        editResource={editResource}
        validationErrors={props.validationErrors}
        hideStudent
      />
    </Card>
  );
};
